import React from "react";
import * as firebase from "firebase";
import "firebase/auth";
import styled from "styled-components";

var firebaseConfig = {
    apiKey: "AIzaSyB897RNYON9sSM64oZwLecjKvSkiYCG-NE",
    authDomain: "bubble-33151.firebaseapp.com",
    databaseURL: "https://bubble-33151.firebaseio.com",
    projectId: "bubble-33151",
    storageBucket: "bubble-33151.appspot.com",
    messagingSenderId: "266587067663",
    appId: "1:266587067663:web:5ed49d55ec379522db9a7a"
};

// Initialize Firebase
firebase.initializeApp(firebaseConfig);

const provider = new firebase.auth.GoogleAuthProvider();

const Login = props => {
    /**
     * Function called when clicking the Login/Logout button.
     */
    // [START buttoncallback]
    const toggleSignIn = () => {
        if (!firebase.auth().currentUser) {
            // [START createprovider]
            // [START signin]
            firebase
                .auth()
                .signInWithRedirect(provider);
            // .then(function (result) {
            //     // This gives you a Google Access Token. You can use it to access the Google API.
            //     // var token = result.credential.accessToken;
            //     // The signed-in user info.
            //     // var user = result.user;
            // })
            // .catch(function (error) {
            //     // Handle Errors here.
            //     // var errorCode = error.code;
            //     // var errorMessage = error.message;
            //     // The email of the user's account used.
            //     // var email = error.email;
            //     // The firebase.auth.AuthCredential type that was used.
            //     // var credential = error.credential;
            //     console.error(error);
            // });
            // [END signin]
        } else {
            // [START signout]
            firebase.auth().signOut();
            console.log('logging out')
            // [END signout]
        }
    };
    // [END buttoncallback]

    /**
     * initApp handles setting up UI event listeners and registering Firebase auth listeners:
     *  - firebase.auth().onAuthStateChanged: This listener is called when the user is signed in or
     *    out, and that is where we update the UI.
     */
    function initApp() {

        // [START getidptoken]
        firebase.auth().getRedirectResult().then(function (result) {
            // This gives you a Google Access Token. You can use it to access the Google API.
            // var token = result.credential.accessToken;
            // The signed-in user info.
            // var user = result.user;
        }).catch(function (error) {
            // Handle Errors here.
            // var errorCode = error.code;
            // var errorMessage = error.message;
            // // The email of the user's account used.
            // var email = error.email;
            // // The firebase.auth.AuthCredential type that was used.
            // var credential = error.credential;
            // [START_EXCLUDE]
            console.error(error);
        }
            // [END_EXCLUDE]
        );
        // [END getidptoken]

        // Listening for auth state changes.
        // [START authstatelistener]
        firebase.auth().onAuthStateChanged(async function (user) {
            if (user) {
                // User is signed in.
                // var displayName = user.displayName;
                // var emailVerified = user.emailVerified;
                // var photoURL = user.photoURL;
                // var isAnonymous = user.isAnonymous;
                // var uid = user.uid;
                // var providerData = user.providerData;
                var email = user.email;
                console.log("logging in from Login");
                if (email === "eric.eriksson@gmail.com" || email === "ilelado@gmail.com") {
                    await props.setLogin();
                } else {
                    await props.setFalse();
                }
                return;
            } else {
                // User is signed out.
                console.log("logging out from Login");
                await props.setLogout();

                return;
            }
        });
        // [END authstatelistener]
        // }
    }

    window.onload = function () {
        initApp();
    };

    if (props.isLogoutButton) {
        return (
            <LogoutButton onClick={toggleSignIn}>
                x
            </LogoutButton>
        );
    } else {
        return (
            <LoginButton onClick={toggleSignIn}>
                Hell yeah, <u>I'm your baby</u>!
            </LoginButton>
        )
    }
};

export default Login;

const LogoutButton = styled.button`
    position: absolute;
    right: 41px;
    top: 32px;
    margin-bottom: 50px;
    background: none;
    border: none;
    color: white;
    font-family: 'Helvetica', sans-serif;
    font-size: 20px;
    font-weight: 100;
    color: #222;
`;

const LoginButton = styled.button`
    font-family: 'Bebas Neue',sans-serif;
    font-size: 26px;
    background: none;
    border: none;
    color: white;
`;



